"use strict";
/*******************************************************************************

    The class that defines the enrollment of a block.

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enrollment = void 0;
var Hash_1 = require("../common/Hash");
var Signature_1 = require("../common/Signature");
var JSONValidator_1 = require("../utils/JSONValidator");
/**
 * The class that defines the enrollment of a block.
 * Convert JSON object to TypeScript's instance.
 * An exception occurs if the required property is not present.
 */
var Enrollment = /** @class */ (function () {
    /**
     * Constructor
     * @param key   A hash of a frozen UTXO
     * @param seed  The nth image of random value
     * @param sig A signature for the message H(K, X, n, R) and the key K, using R
     */
    function Enrollment(key, seed, sig) {
        this.utxo_key = key;
        this.commitment = seed;
        this.enroll_sig = sig;
    }
    /**
     * The reviver parameter to give to `JSON.parse`
     *
     * This function allows to perform any necessary conversion,
     * as well as validation of the final object.
     *
     * @param key   Name of the field being parsed
     * @param value The value associated with `key`
     * @returns A new instance of `Enrollment` if `key == ""`, `value` otherwise.
     */
    Enrollment.reviver = function (key, value) {
        if (key !== "")
            return value;
        JSONValidator_1.JSONValidator.isValidOtherwiseThrow("Enrollment", value);
        return new Enrollment(new Hash_1.Hash(value.utxo_key), new Hash_1.Hash(value.commitment), new Signature_1.Signature(value.enroll_sig));
    };
    /**
     * Collects data to create a hash.
     * @param buffer The buffer where collected data is stored
     */
    Enrollment.prototype.computeHash = function (buffer) {
        this.utxo_key.computeHash(buffer);
        this.commitment.computeHash(buffer);
    };
    /**
     * Serialize as binary data.
     * @param buffer - The buffer where serialized data is stored
     */
    Enrollment.prototype.serialize = function (buffer) {
        this.utxo_key.serialize(buffer);
        this.commitment.serialize(buffer);
        this.enroll_sig.serialize(buffer);
    };
    /**
     * Deserialize as binary data.
     * @param buffer - The buffer to be deserialized
     */
    Enrollment.deserialize = function (buffer) {
        var utxo_key = Hash_1.Hash.deserialize(buffer);
        var commitment = Hash_1.Hash.deserialize(buffer);
        var enroll_sig = Signature_1.Signature.deserialize(buffer);
        return new Enrollment(utxo_key, commitment, enroll_sig);
    };
    /**
     * Returns the data size.
     */
    Enrollment.prototype.getNumberOfBytes = function () {
        return (this.utxo_key.getNumberOfBytes() + this.commitment.getNumberOfBytes() + this.enroll_sig.getNumberOfBytes());
    };
    return Enrollment;
}());
exports.Enrollment = Enrollment;
//# sourceMappingURL=Enrollment.js.map